import { ConsentDTO, CreateCustomerRequestDTO, CustomerActiveDTO, CustomerDTO, CustomerFiltersDTO, EditCustomerRequestDTO, FindAllCustomersResponseDTO, PurchaseDTO } from "./dto";
import { CustomerServiceImpl } from "./serviceImpl";

export interface CustomerService {
    createCustomer(request: CreateCustomerRequestDTO): Promise<void>
    findCustomerById(id: string): Promise<CustomerDTO>
    findAllCustomers(filters: CustomerFiltersDTO): Promise<FindAllCustomersResponseDTO>
    deleteCustomer(id: string): Promise<void>
    editCustomer(id: string, request: EditCustomerRequestDTO): Promise<void>
    otpRequest(request: {
        mail: string
        duration: number
    }): Promise<void>
    otpValidate(consents: ConsentDTO): Promise<string>
    changeStatus(id: string, request: CustomerActiveDTO): Promise<void>
}

export function NewCustomerService(): CustomerService {
    return new CustomerServiceImpl();
}
